/**
 * Shared auth header helper.
 *
 * Returns Bearer token headers for authenticated API calls.
 * Reads auth.currentUser internally — callers never pass user objects.
 *
 * Used by both api.ts (survey endpoints) and billingService.ts.
 */

import { auth } from './firebase';

/**
 * Build Authorization + Content-Type headers from the current Firebase user token.
 *
 * @param forceRefresh - pass true when the token may be stale (e.g. after a long redirect)
 * @throws Error('Not authenticated') when no user is signed in
 */
export async function getIdTokenHeaders(forceRefresh: boolean = false): Promise<HeadersInit> {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Not authenticated');
  }
  const token = await user.getIdToken(forceRefresh);
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}
